import { icons } from "../../exports/npmIcons/icons";

export type IconToken = keyof typeof icons;

export function getIconByKey(key: IconToken) {
  return icons[key];
}
